import script from "./PortfolioReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioReportView.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioReportView.vue?vue&type=style&index=0&id=7caffbfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7caffbfc"]])

export default __exports__